(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-gg-finder]').forEach(finder => {
      if (finder.dataset.ready) return;
      finder.dataset.ready = 'true';
      finder.addEventListener('click', event => {
        const anchor = event.target.closest('a');
        if (!anchor || !finder.contains(anchor) || anchor.hasAttribute('data-gg-price-reset')) return;
        const currentQuery = new URLSearchParams(window.location.search);
        currentQuery.delete('page');
        const target = new URL(anchor.href, window.location.origin);
        target.search = currentQuery.toString();
        anchor.href = target.href;
      });
      if (window.matchMedia('(max-width:749px)').matches && !finder.querySelector('.is-selected')) finder.open = false;
      const query = new URLSearchParams(window.location.search);
      query.delete('page');
      finder.querySelectorAll('.gg-finder__group').forEach(group => {
        const groupTags = [...group.querySelectorAll('[data-gg-tag]')].map(choice => choice.dataset.ggTag);
        group.querySelectorAll('[data-gg-tag] a').forEach(anchor => {
          const choice = anchor.closest('[data-gg-tag]');
          const url = new URL(anchor.href, window.location.origin);
          if (!choice.classList.contains('is-selected')) {
            const parts = url.pathname.split('/');
            const tags = parts[parts.length - 1].split('+').filter(tag => !groupTags.includes(decodeURIComponent(tag)));
            tags.push(choice.dataset.ggTag);
            parts[parts.length - 1] = tags.join('+');
            url.pathname = parts.join('/');
          } else anchor.setAttribute('aria-current', 'true');
          url.search = query.toString();
          anchor.href = url.href;
        });
      });
      finder.querySelectorAll('.gg-finder__chip a,[data-gg-clear]').forEach(anchor => {
        const url = new URL(anchor.href, window.location.origin);
        url.search = query.toString();
        anchor.href = url.href;
      });
      finder.querySelectorAll('[data-gg-value-search]').forEach(input => {
        input.addEventListener('input', () => {
          const text = input.value.trim().toLocaleLowerCase();
          input.closest('[data-gg-group]').querySelectorAll('[data-gg-search]').forEach(choice => {
            choice.hidden = !choice.dataset.ggSearch.toLocaleLowerCase().includes(text);
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once:true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

